import Vue from 'vue';
import { MtButton } from '../MtButton';
import './MtHeaderButton.css';
export default Vue.extend({
    name: 'MtHeaderButton',
    functional: true,
    render: function (h, context) {
        return h(MtButton, {
            on: context.listeners,
            attrs: context.data.attrs,
            staticClass: 'mt-header__button',
            class: [context.data.staticClass, context.data.class],
            style: [context.data.staticStyle, context.data.style],
        }, context.children);
    },
});
//# sourceMappingURL=MtHeaderButton.js.map